import { Component } from '@angular/core';

@Component({
  selector: 'app-edit-projeto',
  templateUrl: './edit-projeto.component.html',
  styleUrls: ['./edit-projeto.component.scss']
})
export class EditProjetoComponent {

}
